export const MAIN_BAR_CONTAINER_ID = 'main-bar-container';
